import React from 'react';

// --- SVG Icons ---
const HomeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#222" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const ChevronRight = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#DA2128" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path>
    <path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path>
  </svg>
);

const PdfIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

const FinancePage = () => {
  // Aapka diya hua updated data yahan integrate kar diya gaya hai
  const reports = [
    { year: '2024-2025', title: 'Annual Report', link: 'https://assocham.org/assocham_backend/assets/pdf/AnnualReturn_ASSOCHAM_2025.pdf', target:"_blank" },
    { year: '2023-2024', title: 'Annual Report', link: 'https://assocham.org/assocham_backend/assets/pdf/AnnualReturn_ASSOCHAM_2024.pdf', target:"_blank" },
    { year: '2020-2021', title: 'Annual Report', link: 'https://assocham.org/assocham_backend/assets/pdf/AnnualReturn_ASSOCHAM_2021.pdf', target:"_blank" },
    { year: '2019-2020', title: 'Annual Report', link: 'https://assocham.org/assocham_backend/assets/pdf/AnnualReturn_ASSOCHAM_2020.pdf', target:"_blank" },
  ];

  return (
    <div style={styles.pageWrapper}>
      {/* CSS for hover effects and responsiveness */}
      <style>
        {`
          .download-btn { transition: background-color 0.3s ease, transform 0.1s ease; }
          .download-btn:hover { background-color: #DA2128 !important; }
          .download-btn:active { transform: scale(0.98); }
          .report-card { transition: box-shadow 0.3s ease; }
          .report-card:hover { box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08) !important; }
          
          /* Responsive Design */
          @media (max-width: 768px) {
            .hero-section { height: 200px !important; padding: 20px !important; }
            .breadcrumb-pill { padding: 6px 10px !important; }
            .report-inner { flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
            .report-middle { margin-left: 0 !important; }
            .report-right { width: 100%; }
            .download-btn { width: 100%; justify-content: center; }
          }
        `}
      </style>

      {/* --- HERO SECTION WITH IMAGE & BREADCRUMB --- */}
      <div className="hero-section" style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        
        {/* Breadcrumb Pill (Top-Left & Smaller) */}
        <div className="breadcrumb-pill" style={styles.breadcrumbPill}>
          <div style={styles.breadcrumbItem}>
            <HomeIcon />
            <span style={styles.breadcrumbText}>HOME</span>
          </div>
          
          <ChevronRight />
          
          <div style={styles.breadcrumbItem}>
            <span style={styles.breadcrumbText}>ABOUT</span>
          </div>
          
          <ChevronRight />
          
          {/* Active Breadcrumb (Red Pill) */}
          <div style={styles.activeBreadcrumb}>
            ABOUT US
          </div>
        </div>
      </div>

      {/* --- MAIN CONTENT SECTION --- */}
      <div style={styles.contentContainer}>
        <div style={styles.listContainer}>
          {reports.map((report, index) => (
            <div key={index} className="report-card" style={styles.cardWrapper}>
              <div className="report-inner" style={styles.cardInner}>
                
                <div style={styles.leftSection}>
                  <CalendarIcon />
                  <span style={styles.yearText}>{report.year}</span>
                </div>

                <div className="report-middle" style={styles.middleSection}>
                  <span style={styles.titleText}>{report.title}</span>
                </div>

                <div className="report-right" style={styles.rightSection}>
                  {/* Added target and rel attributes based on your data */}
                  <a 
                    href={report.link} 
                    target={report.target} 
                    rel="noopener noreferrer"
                    className="download-btn" 
                    style={styles.downloadButton}
                  >
                    Download
                    <PdfIcon />
                  </a>
                </div>
                
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// --- Styles Object ---
const styles = {
  pageWrapper: {
    backgroundColor: '#FFFFFF',
    minHeight: '100vh',
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  
  // Hero Section Styles (Top-Left)
  heroSection: {
    position: 'relative',
    width: '100%',
    height: '350px', 
    backgroundImage: 'url("https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'flex-start', 
    justifyContent: 'flex-start', 
    padding: '40px', 
  },
  heroOverlay: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)', 
  },
  breadcrumbPill: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    padding: '6px 12px', 
    borderRadius: '50px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    gap: '8px', 
  },
  breadcrumbItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  breadcrumbText: {
    fontSize: '13px', 
    fontWeight: '700',
    color: '#222222',
    textTransform: 'uppercase',
  },
  activeBreadcrumb: {
    backgroundColor: '#DA2128', 
    color: '#FFFFFF',
    padding: '6px 16px', 
    borderRadius: '50px',
    fontSize: '13px', 
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },

  // Content Section Styles
  contentContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '60px 20px',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  cardWrapper: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #EAEAEA',
    borderRadius: '12px',
    padding: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  cardInner: {
    backgroundColor: '#FAF7F2', 
    borderRadius: '8px',
    padding: '20px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: '150px',
  },
  yearText: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333333',
  },
  middleSection: {
    flex: 1,
    marginLeft: '40px',
  },
  titleText: {
    fontSize: '18px',
    fontWeight: '400',
    color: '#222222',
  },
  rightSection: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  downloadButton: {
    backgroundColor: '#E68F00', 
    color: '#FFFFFF',
    padding: '10px 24px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
  },
};

export default FinancePage;